import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3ccfe56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head-down" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head-up" }, null, -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "head-title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_7 = { class: "desc" }
const _hoisted_8 = { class: "run-code" }
const _hoisted_9 = { class: "answer-content qanda" }
const _hoisted_10 = ["innerHTML"]

import codeMirror from "codemirror";
import "codemirror/lib/codemirror.css";
// 引入mode
import "codemirror/mode/python/python";
import { ref, onMounted, nextTick, computed } from "vue";
import useClipboard from 'vue-clipboard3';
import { ElMessage } from "element-plus";
import "codemirror/addon/scroll/simplescrollbars.js"
import "codemirror/addon/scroll/simplescrollbars.css"
import { contentRender } from "@/lib/contentRender";


export default /*#__PURE__*/_defineComponent({
  __name: 'CodeHelp',
  props: {
    answerData: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

const { toClipboard } = useClipboard()

let answer = computed(() => {
    return props.answerData.answer
})

let status = ref("think");

let code = ref("");

let mycode = ref(null);

let markDesc = ref("");

const copy = async () => {
    try {
        await toClipboard(answer.value);
        ElMessage.success("复制成功");
    } catch (e) {
        console.error(e)
    }
}

onMounted(() => {
    nextTick(() => {
        code.value = props.answerData.answer;
        if (!props.answerData.think) {
            status.value = "answer";
        }
        codeMirror.fromTextArea(document.getElementById("mycode") as HTMLTextAreaElement, {
            mode: "python",
            theme: "seti",
            lineNumbers: true,
            // readOnly: "nocursor",
            scrollbarStyle: "simple",
        });

        markDesc.value = contentRender(props.answerData.desc);
    })

})


const changeStatus = (val: string) => {
    status.value = val;
}

const closeAnswer = (flag: boolean) => {
    emits('close', flag);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "ai-help",
    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (closeAnswer(false)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("span", {
            class: _normalizeClass(["share-think", { active: _unref(status) === 'think' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (changeStatus('think')))
          }, "思路", 2), [
            [_vShow, _ctx.answerData.think]
          ]),
          _createElementVNode("span", {
            class: _normalizeClass(["share-answer", { active: _unref(status) === 'answer' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (changeStatus('answer')))
          }, "答案", 2)
        ]),
        _hoisted_6,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answerData.think, (item, index) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "qanda",
            key: index
          }, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(item), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(item), 1)
          ])), [
            [_vShow, _unref(status) === 'think' && _ctx.answerData.think]
          ])
        }), 128)),
        _createElementVNode("section", _hoisted_9, [
          _createElementVNode("p", {
            class: "desc",
            innerHTML: _unref(markDesc)
          }, null, 8, _hoisted_10),
          _createElementVNode("div", {
            class: "answer-code run-code",
            onClick: copy
          }, [
            _withDirectives(_createElementVNode("textarea", {
              ref_key: "mycode",
              ref: mycode,
              id: "mycode",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(answer) ? (answer).value = $event : answer = $event))
            }, null, 512), [
              [_vModelText, _unref(answer)]
            ])
          ])
        ])
      ]),
      _createElementVNode("i", {
        class: "el-icon-circle-close",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (closeAnswer(false)))
      })
    ])
  ]))
}
}

})